import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import useForm from 'assets/components/form/hooks/Form';
import Icon from 'assets/components/icon/Icon';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';

export default function ClaimDocumentForm(props: { onSubmit: (docs: Utils.FormData<Model.IClaimDocument>[]) => void }) {
  const { lang } = getLocales();
  const form = useForm<Utils.FormData<Model.IClaimDocument & { formFiles: Model.IUploadableClaimDocument[] }>>({
    default: { formFiles: [] },
    validation: (data, errors) => {
      if (!isEmpty(data.formFiles)) {
        data.formFiles.forEach((formFile, index) => {
          if (!errors.formFiles) errors.formFiles = {};
          if (!errors.formFiles[index]) errors.formFiles[index] = {};
          if (!formFile.newName) errors.formFiles[index].newName = lang.required;
        });
      }
    },
    onSubmit: (data) => {
      const claimDocuments = data?.formFiles?.map((it) => ({
        formFile: it.formFile,
        name: it.newName,
        notes: it.notes,
      }));
      props.onSubmit(claimDocuments);
      form.reload();
    },
  });
  const formFiles = useMemo(
    () =>
      form.data.formFiles &&
      form.data.formFiles.map((it) => ({
        original: it.formFile,
        type: it.formFile.type as Utils.File.MimeType,
        dataUrl: window.URL.createObjectURL(it.formFile),
        name: it.formFile.name,
        newName: it.newName,
        notes: it.notes,
      })),
    [form.data.formFiles]
  );

  return (
    <div style={{ marginLeft: Theme.Size.XL, marginRight: Theme.Size.XL }}>
      <FileInput
        name="files"
        fileLimit={5}
        value={formFiles}
        onChange={({ files }) => {
          const updatedFormFiles = files?.map((file) => ({
            formFile: file.original,
            newName: file.original.name,
            ...file,
          }));
          form.update({ formFiles: updatedFormFiles });
        }}
        class={ThemeFileInputDropzone}
        renderAfter={
          <>
            {formFiles?.map((file, index) => (
              <div key={index} style={{ width: '100%', margin: '10px auto' }}>
                <h6>{file?.name}</h6>
                <TextInput
                  name="newName"
                  label={lang.name}
                  value={file?.newName}
                  error={form.errors?.formFiles[index]?.newName}
                  onChange={({ newName }) => {
                    const updatedFiles = [...form.data.formFiles];
                    updatedFiles[index].newName = newName;
                    form.update({ formFiles: updatedFiles });
                  }}
                />
                <br />
                <MultilineTextInput
                  name="notes"
                  label={lang.notes}
                  value={file?.notes}
                  onChange={({ notes }) => {
                    const updatedFiles = [...form.data.formFiles];
                    updatedFiles[index].notes = notes;
                    form.update({ formFiles: updatedFiles });
                  }}
                />
              </div>
            ))}
          </>
        }
      />
      <br />
      <Button
        render={lang.add}
        media={<Icon class="fas-upload" />}
        onClick={form.submit}
        disabled={form.hasErrors}
        active={!form.hasErrors}
        class={ThemeButtonCircle}
        style={{ marginLeft: 'auto' }}
      />
    </div>
  );
}
